/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
export const SET_INITIALIZE = 'initializationTypes/SET_INITIALIZE';
export const SET_INITIALIZE_SUCCESS = 'initializationTypes/SET_INITIALIZE_SUCCESS';
export const SET_INITIALIZE_FAILURE = 'initializationTypes/SET_INITIALIZE_FAILURE';

export interface SetInitializeAction {
  type: typeof SET_INITIALIZE;
  payload?:any;
}

export interface SetInitializeSuccessAction {
  type: typeof SET_INITIALIZE_SUCCESS;
  payload?:any;
}

export interface SetInitializeFailureAction {
  type: typeof SET_INITIALIZE_FAILURE;
  payload?:any;
}
